const tagManager = (data) =>
  // eslint-disable-next-line angular/window-service
  typeof window.dataLayer !== 'undefined' && window.dataLayer.push(data);

export default tagManager;
